import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { usePageCrumbs } from '@/component/layout/TopNav/usePageCrumbs.ts'
import { getDocumentTitle } from '@/util/documentTitle.ts'

export const useDocumentTitle = () => {
    const { t } = useTranslation()
    const { pathname } = useLocation()
    const crumbs = usePageCrumbs()
    const currentCrumb = crumbs[crumbs.length - 1]?.label ?? ''

    useEffect(() => {
        document.title = getDocumentTitle(t, pathname, currentCrumb)
    }, [currentCrumb, pathname, t])
}
